<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Update Connection RMA Settings</p>
        </header>
        <section class="modal-card-body">
          <!-- General Errors -->
          <div v-if="error" class="mb-md">
            <b-message type="is-danger">{{ error }}</b-message>
          </div>
          <!-- Auto-Approve RMAs -->
          <b-field label="Auto-Approve RMAs After (Hours)">
            <b-numberinput
              v-model="autoApproveRmaHours"
              size="is-medium"
              :controls="false"
              :min="1"
              expanded
              :disabled="saving"  />
          </b-field>
          <!-- Auto-Credit RMAs -->
          <b-field label="Auto-Credit RMAs">
            <b-select v-model="autoCreditRma" expanded :disabled="saving">
              <option :value="0">Disabled</option>
              <option :value="1">Enabled</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button
            type="is-primary"
            native-type="submit"
            :loading="saving"
            :disabled="saving">
            Save Settings
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  data () {
    return {
      autoApproveRmaHours: 0,
      autoCreditRma: 0,
      initialAutoApproveRmaHours: 0,
      initialAutoCreditRma: 0,
      saving: false,
      error: null
    }
  },
  computed: {
    ...mapGetters(['context']),
    autoApproveCredential () {
      return Array.isArray(this.connection.connection_credentials)
        ? this.connection.connection_credentials.find(c => c.code === 'approve_rmas_after_x_hours') || null
        : null
    },
    autoCreditCredential () {
      return Array.isArray(this.connection.connection_credentials)
        ? this.connection.connection_credentials.find(c => c.code === 'auto_credit_rmas') || null
        : null
    },
    autoApproveEndpoint () {
      const base = this.context.route + '/connections/' + this.connection.id + '/credentials/'
      return this.autoApproveCredential ? base + this.autoApproveCredential.id + '/' : base
    },
    autoCreditEndpoint () {
      const base = this.context.route + '/connections/' + this.connection.id + '/credentials/'
      return this.autoCreditCredential ? base + this.autoCreditCredential.id + '/' : base
    }
  },
  methods: {
    save () {
      this.saving = true
      const requests = []
      if (this.autoApproveRmaHours !== this.initialAutoApproveRmaHours) {
        const method = this.autoApproveCredential ? 'patch' : 'post'
        requests.push(this.$http[method](this.autoApproveEndpoint, {
          name: 'Approve RMAs After X Hours',
          code: 'approve_rmas_after_x_hours',
          value: this.autoApproveRmaHours
        }))
      }
      if (this.autoCreditRma !== this.initialAutoCreditRma) {
        const method = this.autoCreditCredential ? 'patch' : 'post'
        requests.push(this.$http[method](this.autoCreditEndpoint, {
          name: 'Auto Credit RMAs',
          code: 'auto_credit_rmas',
          value: this.autoCreditRma
        }))
      }
      if (requests.length === 0) {
        this.$parent.close()
        return
      }
      Promise.all(requests).then(() => {
        this.$emit('saved:connection')
        this.$buefy.toast.open({ type: 'is-success', message: 'RMA Settings updated!' })
        this.$parent.close()
      }).catch(error => {
        if (error.response && 'non_field_errors' in error.response.data) {
          this.error = error.response.data.non_field_errors[0]
        }
      }).finally(() => {
        this.saving = false
      })
    }
  },
  mounted () {
    this.autoApproveRmaHours = this.autoApproveCredential ? this.autoApproveCredential?.value : 0
    this.autoCreditRma = this.autoCreditCredential ? this.autoCreditCredential?.value : 0
    this.initialAutoApproveRmaHours = this.autoApproveRmaHours
    this.initialAutoCreditRma = this.autoCreditRma
  },
  props: ['connection']
}
</script>
